package com.essntl.core.stripe.data.response

import com.essntl.core.stripe.domain.models.Product
import kotlinx.serialization.Serializable

@Serializable
internal data class ProductDto(
    val id: String,
) {
    fun toModel() =
        Product(
            id = id,
        )
}
